import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import './Sidebar.scss';
import { browserHistory } from 'react-router';
import appRoutes from '../../routes/app';
import { IconLogoText, IconBtnMypixel, widgetLogo } from '../../img';  //IconLogo, IconBtnMypixel IconIndropSetting IconIndropSignout,
// IconNotifly, backIcon
import ReactTooltip from 'react-tooltip';
import ContentLoader from 'react-content-loader';
import { getUserActivity, updUserView, updUserClick } from '../../ducks/activity';
import Parser from 'html-react-parser';
// import { Dropdown, DropdownItem, DropdownMenu } from 'styled-dropdown-component'; // DropdownDivider 
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerify: true,
      hidden: true,
      hideShowPopup: true
    };
  }

  componentDidMount() {
    // if (document.getElementById('add_wall_btn'))
    //   document.getElementById('add_wall_btn').style.display = 'flex';
    this.props.getUserActivity();
  }

  componentDidUpdate() {
    //for sidebar active class
    let url = this.props.location.pathname + this.props.location.search;

    if (url === process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type') {
      this.handleSidebarClick(0);
    }
    else if (url === process.env.REACT_APP_ROUTE_PREFIX || url === process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=list') {
      this.handleSidebarClick(1);
    }
    else if (url === process.env.REACT_APP_ROUTE_PREFIX + 'visitor') {
      this.handleSidebarClick(2);
    }
  }

  handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    localStorage.removeItem('e');
    localStorage.removeItem('pvd');
    localStorage.removeItem('WIDNM');
    localStorage.removeItem('WIDTP');
    localStorage.removeItem('WIDSHP');

    localStorage.removeItem('restoreId');
    localStorage.removeItem('ti');
    localStorage.removeItem('csub');
    localStorage.removeItem('istm');
    localStorage.removeItem('role');
    localStorage.removeItem('isbusr');//white_label
    localStorage.removeItem('utyp');
    localStorage.removeItem('isAppsumo');
    localStorage.removeItem('alg');
    localStorage.removeItem('fvicn');
    localStorage.removeItem('isMaster');
    localStorage.removeItem('isPixelIns');
    localStorage.removeItem('is_hide_blackfriday');
    localStorage.removeItem('loginTime');
    localStorage.removeItem('UTM_SIGNUP');
    localStorage.removeItem('rdt_url');
    window.location.href = '/login';
  }

  updLastSeen = () => {
    let countActivityNotif = 0;
    if (this.props.activity && this.props.activity.length > 0) {
      countActivityNotif = this.props.activity.filter(x => x.iv === false).length;
    }
    if (countActivityNotif !== 0) {
      this.props.updUserView();
    }
  }

  updUserClick = (id, val) => {
    if (val !== true) {
      let obj = {
        id: id
      };
      this.props.updUserClick(obj);
    }
  }

  addWidget = () => {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type');
    document.getElementById('add_wall_btn').style.display = 'none';
    this.setState(this.state);
  }

  handleSidebarClick = (key) => {
    let screenSize = window.innerHeight;
    if (document.getElementById('Wdgt_sidebar_Blk')) {
      if (screenSize <= 800) {
        document.getElementById('Wdgt_sidebar_Blk').style.cssText += 'transform: translate(0px, ' + (key * 90) + 'px);';
      }
      else if (screenSize <= 700) {
        document.getElementById('Wdgt_sidebar_Blk').style.cssText += 'transform: translate(0px, ' + (key * 65) + 'px);';
      }
      else {
        document.getElementById('Wdgt_sidebar_Blk').style.cssText += 'transform: translate(0px, ' + (key * 90) + 'px);';
      }
    }
    // if (document.getElementById('Wdgt_sidebar_Blk')) {
    //   document.getElementById('Wdgt_sidebar_Blk').style.cssText += 'transform: translate(0px, ' + (key * 90) + 'px);';
    // }
  }

  setHiddenAppOption = (val) => {
    this.state.hidden = val;
    this.setState(this.state);
  }

  changeApp = (app) => {
    // let link = 'https://www.wisernotify.com/Join-beta-social-wall/?ti={JWT}&from={FROM}&e={EMAIL}&n={NAME}&ind={IND}';
    // link = link.replace(/{JWT}/g, localStorage.getItem('authToken'))
    //   .replace(/{IND}/g, this.props.profile.indtry ? this.props.profile.indtry : '')
    //   .replace(/{EMAIL}/g, this.props.profile.e)
    //   .replace(/{FROM}/g, 'dashboard')
    //   .replace(/{NAME}/g, this.props.profile.fn ? this.props.profile.fn : this.props.profile.un);
    // window.open(link, 'focus');

    ////track click event
    try {
      let tracker = window.ga.getAll()[0];
      tracker.send('event', 'Product Button Click', 'SocialWall', this.props.profile ? this.props.profile.e : '', { transport: 'beacon' });
    } catch (error) {
      console.log(error);
    }
    let _url = '';
    if (app == 'wisernotify') {
      if (this.props.profile && this.props.profile.brand && this.props.profile.brand.wurl !== '' && this.props.profile.brand.wurl !== undefined) {
        _url = 'https://' + this.props.profile.brand.wurl;
      }
      else {
        _url = process.env.REACT_APP_WISERNOTIFY_DOMAIN;
      }
    }
    else {
      _url = process.env.REACT_APP_WIDGETHUB_DOMAIN + 'widget/';
    }
    // window.open(_url, 'focus');
    let myWindow = window.open(_url, 'notifyWindow');
    myWindow.focus();
  }

  displayPlan = (typ) => {
    if (window.Froged && typ == 'plan') {
      window.Froged('track', 'widget_add_on', {
        click_event: 'widget addon click'  // application name
      });
    }
    window.open(process.env.REACT_APP_WISERNOTIFY_DOMAIN + 'plan?sec=addon');
  }


  render() {
    // document.getElementById('add_wall_btn').style.display = ' block';
    let countActivityNotif = 0;
    if (this.props.activity && this.props.activity.length > 0) {
      countActivityNotif = this.props.activity.filter(x => x.iv === false).length;
    }
    const url = this.props.location.pathname + this.props.location.search;
    const upMenu = appRoutes.filter(x => x.type == 'up');

    //display agency logo as a favicon
    if (window.location.host !== 'app.wisernotify.com') {
      if (this.props.profile && this.props.profile.brand && this.props.profile.brand.wurl) {
        let _favIcn = this.props.profile.brand.fvicn ? this.props.profile.brand.fvicn : this.props.profile.brand.lg ? this.props.profile.brand.lg : 'https://storage.googleapis.com/wiserimg/user_img/default_company.png';
        var link;
        // if (this.props.profile.brand.fvicn) {
        link = document.createElement('link');
        link.rel = 'icon';
        link.href = _favIcn;
        document.head.appendChild(link);
        localStorage.setItem('fvicn', _favIcn);
        //for sidebar logo
        if (this.props.profile.brand.lg) {
          localStorage.setItem('alg', this.props.profile.brand.lg);
        } else {
          localStorage.setItem('alg', 'https://storage.googleapis.com/wiserimg/user_img/default_company.png');
        }
      }
      if (this.props.profile && this.props.profile.brand && this.props.profile.brand.bn) {
        document.title = this.props.profile.brand.bn;
      }
    }
    return (
      <div id="side-menu">
        <div className="header header-new">
          <div className="toolbar-left pull-left logo-side-app">
            <div className="logo-container">
              <div className="logo-block">
                <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}>
                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" viewBox="0 0 35 19">
                    <g id="Group_27865" data-name="Group 27865" transform="translate(75.503 -1134.629)">
                      <path id="Union_15" data-name="Union 15" d="M18.713,14.956,10.186,3.8a2.307,2.307,0,0,1-.449-1.783,2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l6.509,8.519,1.753-2.3a2.6,2.6,0,0,1,3.514-.529,2.36,2.36,0,0,1,1,1.557,2.307,2.307,0,0,1-.449,1.783l-3.63,4.753a2.5,2.5,0,0,1-.242.271,2.416,2.416,0,0,1-.488.441,2.6,2.6,0,0,1-3.51-.529Zm-9.706,0L.48,3.8A2.307,2.307,0,0,1,.031,2.014a2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l8.526,11.159a2.307,2.307,0,0,1,.449,1.783,2.36,2.36,0,0,1-1,1.557,2.6,2.6,0,0,1-3.511-.529Z" transform="translate(-74.999 1136.748)" fill="#212121" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"></path><path id="Polygon_10" data-name="Polygon 10" d="M3.017.311A.772.772,0,0,1,3.625,0a.721.721,0,0,1,.6.3l2.753,3.8a.725.725,0,0,1,.048.765.772.772,0,0,1-.669.41L.73,5.356a.718.718,0,0,1-.656-.391.733.733,0,0,1,.072-.77Z" transform="translate(-46.829 1134.634) rotate(35.025)" fill="#645cfc"></path>
                    </g>
                  </svg>
                  <img style={{ display: 'none' }} className="logo-icon" src={widgetLogo} alt="notifly" /> 
                  */}


                  {
                    localStorage.getItem('isbusr') == 'true' ?
                      this.props.profile && this.props.profile.brand && this.props.profile.brand.lg ?
                        <img className="logo-icon" src={this.props.profile.brand.lg} alt="notifly" />
                        :
                        <img className="logo-icon" src='https://storage.googleapis.com/wiserimg/user_img/default_company.png' alt="notifly" />
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" viewBox="0 0 35 19">
                        <g id="Group_27865" data-name="Group 27865" transform="translate(75.503 -1134.629)">
                          <path id="Union_15" data-name="Union 15" d="M18.713,14.956,10.186,3.8a2.307,2.307,0,0,1-.449-1.783,2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l6.509,8.519,1.753-2.3a2.6,2.6,0,0,1,3.514-.529,2.36,2.36,0,0,1,1,1.557,2.307,2.307,0,0,1-.449,1.783l-3.63,4.753a2.5,2.5,0,0,1-.242.271,2.416,2.416,0,0,1-.488.441,2.6,2.6,0,0,1-3.51-.529Zm-9.706,0L.48,3.8A2.307,2.307,0,0,1,.031,2.014a2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l8.526,11.159a2.307,2.307,0,0,1,.449,1.783,2.36,2.36,0,0,1-1,1.557,2.6,2.6,0,0,1-3.511-.529Z" transform="translate(-74.999 1136.748)" fill="#212121" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"></path><path id="Polygon_10" data-name="Polygon 10" d="M3.017.311A.772.772,0,0,1,3.625,0a.721.721,0,0,1,.6.3l2.753,3.8a.725.725,0,0,1,.048.765.772.772,0,0,1-.669.41L.73,5.356a.718.718,0,0,1-.656-.391.733.733,0,0,1,.072-.77Z" transform="translate(-46.829 1134.634) rotate(35.025)" fill="#645cfc"></path>
                        </g>
                      </svg>
                  }


                </Link>
              </div>
            </div>
            {
              // localStorage.getItem('isbusr') !== 'true' &&
              <ul className="tb-nav-list sidebar-user-btmview">
                {
                  // (this.props.profile &&
                  //   this.props.profile.iaplcblwdgthb == true &&
                  //   this.props.profile && this.props.profile.userTeam == undefined) &&
                  // (
                  //   this.props.profile &&
                  //   (this.props.profile && this.props.profile.isbusr !== true && localStorage.getItem('isbusr') !== 'true' && localStorage.getItem('utyp') == 'appsumo') ||
                  //   (this.props.profile && this.props.profile.isbusr !== true && localStorage.getItem('isbusr') !== 'true' && this.props.profile.csub !== 'free' && this.props.profile.csub !== 'undefined') ||
                  //   (this.props.profile && this.props.profile.isbusr !== true && localStorage.getItem('isbusr') !== 'true' && this.props.profile.userTeam !== undefined)
                  // ) &&

                  // <li className='item-user-btmview'>
                  //   <div className="nf-dropdown-wrapper">
                  //     <div className="nf-dropdown dropdown-app-list">
                  //       <Dropdown>
                  //         <a className='' id="dLabel" dropdowntoggle='' data-target="#" data-toggle="dropdown" role="button" onClick={() => this.setHiddenAppOption(!this.state.hidden)} aria-haspopup="true" aria-expanded="false">

                  //           <svg className='fill-brand-color' xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                  //             <g id="Group_27866" data-name="Group 27866" transform="translate(0.5 0.499)">
                  //               <path id="Path_58076" data-name="Path 58076" d="M-11111,569h-6.083v-6.242h6.083V569Zm-7.879,0h-6.083v-6.242h6.083V569Zm-7.879,0h-6.086v-6.242h6.086V569Zm15.758-7.882h-6.083V554.88h6.083v6.238Zm-7.879,0h-6.083V554.88h6.083v6.238Zm-7.879,0h-6.086V554.88h6.086v6.238Zm15.758-7.882h-6.083V547h6.083v6.235Zm-7.879,0h-6.083V547h6.083v6.235Zm-7.879,0H-11133V547h6.242v6.235Z" transform="translate(11133 -547)" fill="#645cfc" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                  //             </g>
                  //           </svg>
                  //           <div className='dropdown-app-name'>
                  //             <h5 className='dropdown-app-name-title'>Apps
                  //               {/* <span className='sidebar-new-tag'>New</span> */}
                  //             </h5>
                  //             <h6 className='dropdown-app-name-sunttl'>Social wall </h6>
                  //           </div>
                  //           <div className='dd-app-arrow'>
                  //             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
                  //               <path id="Path_20241" data-name="Path 20241" d="M13.2,4.955l1.1,1.083-6,5.917-6-5.917,1.1-1.083,4.9,4.835.065-.064Z" transform="translate(-2.294 -4.955)" fill="#8392a5" />
                  //             </svg>
                  //           </div>

                  //           <ReactTooltip id="moreop" aria-haspopup='true' role='example'>
                  //             <p>More option</p>
                  //           </ReactTooltip>
                  //         </a>
                  //         <DropdownMenu hidden={this.state.hidden} toggle={() => this.setHiddenAppOption(!this.state.hidden)} className="nf-dropdown-block nf-dropdown-userheader dropdown-app-box">
                  //           <div>
                  //             <div className='item-moreoption-label'>Our Apps</div>
                  //             <div className='item-moreoption-block'>
                  //               {/* { */}
                  //               <DropdownItem className="user-menu-submenu dropdown-app-item" >
                  //                 <a className='submenu-wn-menu' href='#' onClick={() => this.changeApp('wisernotify')}>
                  //                   <span className='app-item-iconbox'>
                  //                     Social Proof
                  //                   </span>
                  //                   <div className='item-ddapp-img'>
                  //                     <img src={wisernotiapp} alt="" />
                  //                   </div>
                  //                   <div className='app-item-install'>
                  //                     <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                  //                       <path id="Path_1188" data-name="Path 1188" d="M9.789,2.29a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,9.789,2.29Zm0,13.425A5.925,5.925,0,1,1,15.714,9.79a5.925,5.925,0,0,1-5.925,5.925ZM12.6,7.354l-4,4.039L6.85,9.739a.789.789,0,0,0-1.094,0,.833.833,0,0,0,0,1.1l2.331,2.287a.788.788,0,0,0,1.1,0l4.553-4.608h0a.82.82,0,0,0-.044-1.16A.8.8,0,0,0,12.6,7.354Z" transform="translate(-2.289 -2.29)" fill="#645CFC" />
                  //                     </svg>
                  //                     <span className='app-item-install-text'>Installed</span>
                  //                   </div>
                  //                 </a>
                  //               </DropdownItem>
                  //               <DropdownItem className="user-menu-submenu dropdown-app-item dropdown-app-item-beta" >
                  //                 <a className='submenu-wn-menu active-app'> {/*onClick={() => this.changeApp('widgethub')}*/}
                  //                   <span className='app-item-iconbox'>
                  //                     Social Wall
                  //                     <div className='ribbon-beta'>New</div>
                  //                   </span>
                  //                   <div className='item-ddapp-img'>
                  //                     <img src={wisersocialwallapp} alt="" />
                  //                   </div>
                  //                   <div className='app-item-app-ft'>
                  //                     <label className='uuser-submenu-jointext'>
                  //                       Explore Now
                  //                     </label>
                  //                     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10">
                  //                       <path id="Path_58049" data-name="Path 58049" d="M9.608,6.357H-2V7.643H9.608L6.255,11.091,7.139,12,12,7,7.139,2l-.884.909Z" transform="translate(2 -2)" fill="#645CFC" />
                  //                     </svg>
                  //                   </div>
                  //                 </a>
                  //               </DropdownItem>
                  //             </div>
                  //           </div>
                  //         </DropdownMenu>
                  //       </Dropdown>
                  //     </div>
                  //   </div>
                  // </li>
                  <div className='tab-apps-new'>
                    <ul>
                      <li>
                        <a href="#" onClick={() => this.changeApp('wisernotify')}>
                          <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 2H2V3.9H18V2Z" fill="#8392A5" /><path d="M18 4.85742H2V6.75742H18V4.85742Z" fill="#8392A5" /><path d="M8 2H7V6.8H8V2Z" fill="white" /><path d="M7 3.42871H2V4.85728H7V3.42871Z" fill="#8392A5" /><path d="M18 10H2V11.9H18V10Z" fill="#8392A5" /><path d="M18 12.8574H2V14.7574H18V12.8574Z" fill="#8392A5" /><path d="M8 10H7V15H8V10Z" fill="white" /><path d="M7 11.4287H2V12.8573H7V11.4287Z" fill="#8392A5" /></svg>
                          Social Proof </a>
                      </li>
                      <li className='active'>
                        <a href='#'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
                            <path id="Path_66172" data-name="Path 66172" d="M17.857,0H2.143A2.329,2.329,0,0,0,.628.541,1.727,1.727,0,0,0,0,1.846V14.154a1.727,1.727,0,0,0,.628,1.306A2.329,2.329,0,0,0,2.143,16H17.857a2.329,2.329,0,0,0,1.515-.541A1.727,1.727,0,0,0,20,14.154V1.846A1.727,1.727,0,0,0,19.372.541,2.329,2.329,0,0,0,17.857,0Zm.714,6.154h-5V9.846h5v1.231H7.857v3.692H6.429V11.077h-5V9.846H12.143V6.154H1.429V4.923h5V1.231H7.857V4.923H18.571Z" fill="#645cfc" />
                          </svg>
                          Social Wall</a>
                      </li>
                    </ul>
                  </div>
                }
              </ul>
            }
          </div>
          <div className="toolbar-right pull-right">
            <ul className="list-unstyled topbar-menu float-end">
              {/* <li className="notification-list dropdown hdr-user-dd" onMouseEnter={() => this.updLastSeen()}>
              <Link to='#'>
                <svg xmlns="http://www.w3.org/2000/svg" width="25.5" height="25.75" viewBox="0 0 25.5 25.75">
                  <g id="Group_9504" data-name="Group 9504" transform="translate(-1468.249 -20)">
                    <g id="Group_9503" data-name="Group 9503" transform="translate(1468.285 20.286)" opacity="0.7">
                      <path id="Path_21022" data-name="Path 21022" d="M12.714.714a8.194,8.194,0,0,1,7.913,8.449c0,9.4,3.216,11.265,4.087,11.265h-24c.877,0,4.087-1.873,4.087-11.265A8.194,8.194,0,0,1,12.714.714Z" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" opacity="0.7" />
                      <path id="Path_21023" data-name="Path 21023" d="M7.857,17.62a2.211,2.211,0,0,0,4.286,0" transform="translate(2.715 5.429)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" opacity="0.7" />
                    </g>
                    {countActivityNotif != 0 && <circle id="Ellipse_640" data-name="Ellipse 640" cx="3" cy="3" r="3" transform="translate(1484 20)" fill="red" />}
                  </g>
                </svg>
              </Link>
              <div className="sidenav-dd-hover">
                <div className="away-admin-block">
                  <div className="away-admin-details">
                    <img className="avatar-media" src={this.props.profile && this.props.profile.iu ? this.props.profile.iu : 'https://storage.googleapis.com/widget_img/widget/defult-user.png'} alt="avtar" />
                    <div className="avatar-part-right">
                      <div data-tip data-for='name-profile' className="avatar-name">{this.props.profile && this.props.profile.fn}</div>
                      <div data-tip data-for='email-profile' className="avatar-email">{this.props.profile && this.props.profile.e}</div>
                      <ReactTooltip id='name-profile' aria-haspopup='true' role='example'>
                        <p>{this.props.profile && this.props.profile.fn}</p>
                      </ReactTooltip>
                      <ReactTooltip id='email-profile' aria-haspopup='true' role='example'>
                        <p>{this.props.profile && this.props.profile.e}</p>
                      </ReactTooltip>
                    </div>
                  </div> 
                  <ul className="dd-hover-list">
                    {this.props.activity && this.props.activity.length > 0 ?
                      this.props.activity.map((x, i) => {
                        return <li key={i}>
                          <Link className="" to={x.rc} onClick={() => this.updUserClick(x._id, x.ic)}>
                            <span>{x.m}</span>
                          </Link>
                        </li>;
                      })
                      :
                      <li>
                        <span>No activity found.</span>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </li> */}
              {/* <li className="support-block">
              <Link to='#'>
                <svg xmlns="http://www.w3.org/2000/svg" width="25.5" height="25.5" viewBox="0 0 25.5 25.5">
                  <g id="Group_9502" data-name="Group 9502" transform="translate(0.036 0.036)">
                    <path id="Path_21024" data-name="Path 21024" d="M.714,12.714a12,12,0,1,0,12-12,12,12,0,0,0-12,12Z" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" opacity="0.7" />
                    <path id="Path_21025" data-name="Path 21025" d="M7.857,8.484a2.769,2.769,0,1,1,2.769,2.769V13.1" transform="translate(2.088 1.462)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" opacity="0.7" />
                    <path id="Path_21026" data-name="Path 21026" d="M10.244,13.331a1.078,1.078,0,1,0,1.078,1.078,1.078,1.078,0,0,0-1.078-1.078Z" transform="translate(2.471 3.688)" fill="#656565" opacity="0.7" />
                  </g>
                </svg>
              </Link>
            </li> */}

              <li className="tb-nav-addwgt" id='add_wall_btn'>
                <button className="nf-btn nf-btn-default nf-btn-addwall" onClick={() => this.addWidget()}>Add Wall</button>
              </li>

              {
                this.props.profile &&
                  (this.props.profile.isbusr !== true && localStorage.getItem('isbusr') !== 'true') &&
                  (this.props.profile.addonqty == 0 || this.props.profile.addonqty == undefined) ?
                  <li className="tb-nav-plan tb-nav-link" id='' onClick={() => this.displayPlan('plan')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                      <path id="lightning-bolt-outline" d="M10.167,7.93V9.182H13.3L11.833,12.07V10.818H8.7L10.167,7.93M11.833,1,6,12.455h4.167V19L16,7.545H11.833Z" transform="translate(-6 -1)" fill="#645cfc" />
                    </svg>
                    <div className="text-side-tag GTMtrack_buysocialwall">Buy Social Wall <span className='tag-50per'>50% OFF</span> </div>
                  </li>
                  :
                  localStorage.getItem('isbusr') !== 'true' &&
                  <li className="header-navtop-plan" onClick={() => this.displayPlan()}>
                    <span className='header-plan-btn'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                        <path id="lightning-bolt-outline" d="M10.167,7.93V9.182H13.3L11.833,12.07V10.818H8.7L10.167,7.93M11.833,1,6,12.455h4.167V19L16,7.545H11.833Z" transform="translate(-6 -1)" fill="#8392A5" />
                      </svg>
                      <span style={{ paddingLeft: '4px' }}>Plan</span>
                    </span>
                  </li>
              }

              <li className="tb-nav-infoweb" style={{ display: 'none' }}>
                <div className="btn-add-notification btn-infoweb" id="">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="Path_58079" data-name="Path 58079" d="M-20444,7704a8.01,8.01,0,0,1,8-8,8.015,8.015,0,0,1,8,8,8.013,8.013,0,0,1-8,8A8.008,8.008,0,0,1-20444,7704Zm1.744-.026a6.289,6.289,0,0,0,6.162,6.28h.092a6.268,6.268,0,0,0,6.254-6.28,6.263,6.263,0,0,0-6.254-6.254A6.265,6.265,0,0,0-20442.256,7703.976Zm5.648,3.222v-1.185h1.18v1.185Zm.025-2.027a4.318,4.318,0,0,1,.154-1.021,1.986,1.986,0,0,1,.652-.718l.348-.287a1.179,1.179,0,0,0,.309-.308,1.084,1.084,0,0,0,.221-.657,1.254,1.254,0,0,0-.242-.759.931.931,0,0,0-.852-.354h0a.567.567,0,0,0-.088,0,1,1,0,0,0-.816.431,1.591,1.591,0,0,0-.256.754h-1.242a2.16,2.16,0,0,1,.934-1.821,2.5,2.5,0,0,1,1.387-.426,2.825,2.825,0,0,1,1.789.564,1.753,1.753,0,0,1,.684,1.544,1.769,1.769,0,0,1-.287,1.016,3.3,3.3,0,0,1-.709.657l-.363.272a1.184,1.184,0,0,0-.391.605,2.1,2.1,0,0,0-.072.513Z" transform="translate(20444 -7695.998)" fill="#8392a5"></path></svg>
                </div>
              </li>
              <li className="dropdown hdr-user-dd">
                <span className="tb-rghmenu-bdrleft" style={{ left: '-18px' }}></span>
                <Link>
                  <span className="account-user-avatar">
                    <img src={this.props.profile && this.props.profile.iu ? this.props.profile.iu : 'https://storage.googleapis.com/widget_img/widget/defult-user.png'} alt="user" />
                  </span>
                  <span className="avatar-details">
                    <span className="account-user-name">{this.props.profile && this.props.profile.fn}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5">
                      <path id="Path_20238" data-name="Path 20238" d="M9.562,4.955l.732.773-4,4.227-4-4.227.732-.773L6.294,8.408l.043-.046Z" transform="translate(-2.294 -4.955)" fill="#8392a5" />
                    </svg>
                  </span>
                </Link>
                <div className="sidenav-dd-hover">
                  <div className="away-admin-block">
                    {/* <div className="away-admin-details">
                    <img className="avatar-media" src={this.props.profile && this.props.profile.iu ? this.props.profile.iu : 'https://storage.googleapis.com/widget_img/widget/defult-user.png'} alt="avtar" />
                    <div className="avatar-part-right">
                      <div data-tip data-for='name-profile' className="avatar-name">{this.props.profile && this.props.profile.fn}</div>
                      <div data-tip data-for='email-profile' className="avatar-email">{this.props.profile && this.props.profile.e}</div>
                      <ReactTooltip id='name-profile' aria-haspopup='true' role='example'>
                        <p>{this.props.profile && this.props.profile.fn}</p>
                      </ReactTooltip>
                      <ReactTooltip id='email-profile' aria-haspopup='true' role='example'>
                        <p>{this.props.profile && this.props.profile.e}</p>
                      </ReactTooltip>
                    </div>
                  </div> */}
                    <ul className="dd-hover-list">
                      {/* <li>
                      <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}profile`}>
                        <img src={IconIndropSetting} alt="Widget" /> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17.5 17.5">
                          <g id="streamline-icon-interface-user-single_20x20" data-name="streamline-icon-interface-user-single@20x20" transform="translate(-1.917 0.036)" opacity="0.7">
                            <path id="Path_20986" data-name="Path 20986" d="M5.357,4.714a4,4,0,1,0,4-4,4,4,0,0,0-4,4Z" transform="translate(1.31)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_20987" data-name="Path 20987" d="M17.167,18.864a8.44,8.44,0,0,0-8-6,8.44,8.44,0,0,0-8,6Z" transform="translate(1.5 -2.15)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          </g>
                        </svg>
                        <span>Profile</span>
                      </Link>
                    </li> */}
                      {/* <li>
                      <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}plan`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 17.614 20.644">
                          <g id="streamline-icon-interface-file-multiple_20x20" data-name="streamline-icon-interface-file-multiple@20x20" transform="translate(-1.323 0.064)" opacity="0.7">
                            <path id="Path_21014" data-name="Path 21014" d="M0,0,11.422.02l.026,14.7L.026,14.7Z" transform="matrix(0.986, -0.165, 0.165, 0.986, 2.186, 5.2)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21015" data-name="Path 21015" d="M5.591,8.565l5.635-.934" transform="translate(0.072 0.07)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21016" data-name="Path 21016" d="M6.146,11.875l5.635-.932" transform="translate(0.083 0.104)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21017" data-name="Path 21017" d="M6.7,15.183l3.381-.56" transform="translate(0.095 0.141)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21018" data-name="Path 21018" d="M7.837.714l9.132.354a1.146,1.146,0,0,1,.795.361,1.121,1.121,0,0,1,.3.812l-.452,11.471" transform="translate(0.119 0)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          </g>
                        </svg>
                        <span>Plan</span>
                      </Link>
                    </li> */}
                      {/* <li>
                      <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}payment`}>
                        <img src={IconIndropSetting} alt="Widget" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 17.5 18.5">
                          <g id="streamline-icon-programming-script-2_20x20" data-name="streamline-icon-programming-script-2@20x20" transform="translate(-0.679 0.036)" opacity="0.7">
                            <path id="Path_21005" data-name="Path 21005" d="M12.762,4.637V15.1A2.641,2.641,0,0,1,10.1,17.714H1.429A2.641,2.641,0,0,0,4.1,15.1V3.33A2.641,2.641,0,0,1,6.762.714H15.1" transform="translate(0 0)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21006" data-name="Path 21006" d="M15.9.714h0A2.311,2.311,0,0,1,18.238,3v.981a.66.66,0,0,1-.667.654h-4V3A2.311,2.311,0,0,1,15.9.714Z" transform="translate(-0.81 0)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21007" data-name="Path 21007" d="M8.571,5.714h2" transform="translate(-0.476 -0.423)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21008" data-name="Path 21008" d="M7.143,10h3.333" transform="translate(-0.381 -0.786)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21009" data-name="Path 21009" d="M7.143,14.286h3.333" transform="translate(-0.381 -1.148)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          </g>
                        </svg>
                        <span>Billing & Invoices</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`}>
                        <img className="" src={IconIndropSetting} alt="Widget" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17.5 17.5">
                          <g id="streamline-icon-mail-chat-bubble-typing-square_20x20" data-name="streamline-icon-mail-chat-bubble-typing-square@20x20" transform="translate(0.036 0.036)" opacity="0.7">
                            <path id="Path_21010" data-name="Path 21010" d="M5.713,9.187a.615.615,0,1,0,.615-.615A.615.615,0,0,0,5.713,9.187Z" transform="translate(-0.692 -1.088)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21011" data-name="Path 21011" d="M10,9.187a.615.615,0,1,0,.615-.615A.615.615,0,0,0,10,9.187Z" transform="translate(-1.286 -1.088)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21012" data-name="Path 21012" d="M14.286,9.187a.615.615,0,1,0,.615-.615A.615.615,0,0,0,14.286,9.187Z" transform="translate(-1.879 -1.088)" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                            <path id="Path_21013" data-name="Path 21013" d="M5.637,15.484.714,16.714l1.231-3.692V1.945A1.231,1.231,0,0,1,3.176.714H15.484a1.231,1.231,0,0,1,1.231,1.231V14.253a1.231,1.231,0,0,1-1.231,1.231Z" fill="none" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          </g>
                        </svg>
                        <span>Feedback</span>
                      </Link>
                    </li> */}
                      <li onClick={this.handleLogout}>
                        <div className="link-sout">
                          {/* <img src={IconIndropSignout} alt="Widget" /> */}
                          <svg id="login" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="Vector" d="M0,3.381C.206.98,1.439,0,4.136,0h.087C7.2,0,8.392,1.194,8.392,4.174V8.522C8.392,11.5,7.2,12.7,4.223,12.7H4.136c-2.677,0-3.91-.97-4.129-3.331" transform="translate(5.943 1.658)" fill="none" stroke="#292d32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path><path id="Vector-2" data-name="Vector" d="M0,0H8.578" transform="translate(1.332 8)" fill="none" stroke="#292d32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path><path id="Vector-3" data-name="Vector" d="M0,0,2.231,2.231,0,4.462" transform="translate(8.435 5.769)" fill="none" stroke="#292d32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path><path id="Vector-4" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0"></path></svg>
                          <span>Logout</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

            </ul>
          </div>
        </div>
        <div className='left side-menu sm-navigation'>
          {!this.props.profile && this.props.loading == true ?
            <ContentLoader
              height={1000}
              width={87}
              speed={2}
              primaryColor="#fff"
              secondaryColor="#eceef4">
              <rect x="10" y="14" rx="0" ry="0" width="67" height="64" />
              <rect x="2" y="112" rx="0" ry="0" width="85" height="7" />
              <rect x="24" y="151" rx="0" ry="0" width="35" height="35" />
              <rect x="24" y="227" rx="0" ry="0" width="35" height="35" />
              <rect x="24" y="305" rx="0" ry="0" width="35" height="35" />
              <rect x="24" y="383" rx="0" ry="0" width="35" height="35" />
              <rect x="25" y="460" rx="0" ry="0" width="35" height="35" />
              <rect x="25" y="539" rx="0" ry="0" width="35" height="35" />
              <rect x="10" y="617" rx="0" ry="0" width="67" height="7" />
              <rect x="25" y="659" rx="0" ry="0" width="35" height="35" />
              <rect x="25" y="736" rx="0" ry="0" width="35" height="35" />
              <circle cx="43" cy="925" r="20" />
              <rect x="25" y="813" rx="0" ry="0" width="35" height="35" />
            </ContentLoader>
            :
            <div id='hide-sidnav' className={this.state.isVerify ? 'nf-sidenav' : 'nf-sidenav hide-pixel-verify'} >
              <div className="nf-sidebar-header" style={{ display: 'none' }}>
                {
                  localStorage.getItem('isbusr') == 'true' ?
                    this.props.profile && this.props.profile.brand && this.props.profile.brand.lg ?
                      <div className="logo-block ">
                        <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon" src={this.props.profile.brand.lg} alt="notifly" /></Link>
                      </div>
                      :
                      <div className="logo-block">
                        <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon" src='https://storage.googleapis.com/wiserimg/user_img/default_company.png' alt="notifly" /></Link>
                      </div>
                    :
                    <div className="logo-block 56">
                      <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon" src={widgetLogo} alt="notifly" /></Link>
                      <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon-text" src={IconLogoText} alt="notifly" /></Link>
                    </div>
                }
              </div>
              <div className="nf-sidebar-scroll nf-sidebar-content">
                <ul className="nf-sidebar-block">
                  {localStorage.getItem('pvd') != 'shopify' && upMenu.map((prop, key) => {
                    return (
                      <li className={prop.menuhover == undefined && prop.submenu == undefined ? 'nf-sidebar-link' : 'hover_submenu'} key={key}>
                        <Link to={prop.path} activeClassName='side-active' className={((prop.path == process.env.REACT_APP_ROUTE_PREFIX + 'wdlist' && url == process.env.REACT_APP_ROUTE_PREFIX) || prop.path == url) ? 'side-active wdsidebar' : 'wdsidebar'} id={`sidebarlink_${key}`}>
                          {Parser(prop.icon)}
                          {/* <i className={`iconmoon ${prop.icon} `} data-tip data-for={`upMenu ${key} `}></i> */}
                          <span className='label-main-menu'>{prop.name}</span>
                          {/* <ReactTooltip id={`upMenu ${key} `} aria-haspopup='true' role='example'>
                            <p>{prop.name}</p>
                          </ReactTooltip> */}
                          {/* submenu open */}
                          {(prop.menuhover == true || prop.submenu !== undefined) &&
                            <div className='nav-menu--dropdown'>
                              <ul className='sidebar-submenu'>
                                {prop.menuhover &&
                                  prop.submenu.map((sec, i) => {
                                    return (
                                      <li className={`menu-item-submenu_${key}`} key={i}>
                                        <Link className='item-submenu-link' activeClassName='is-active' to={sec.subpath} >
                                          <ReactTooltip id="" aria-haspopup='true' role='example'>
                                            <p>{sec.subname}</p>
                                          </ReactTooltip>
                                          <span>{sec.subname}</span>
                                        </Link>
                                      </li>
                                    );
                                  })
                                }
                              </ul>
                            </div>
                          }
                        </Link>
                      </li>
                    );
                  })
                  }
                </ul>
                <div className="sidebar-ani-block is-active" id='Wdgt_sidebar_Blk'></div>

                <div className="mypixel-nav" style={{ display: 'none' }}>
                  <Link className="nf-btn nf-btn-default nf-btn-icon nf-btn-min15x" to={`${process.env.REACT_APP_ROUTE_PREFIX}pixel`} data-tip data-for='addwidget'>
                    <img className="" src={IconBtnMypixel} alt="notifly" />
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50">  Embed
                    <g id="Icons" transform="translate(-27.369 -14.593)">
                      <rect id="Rectangle_1662" data-name="Rectangle 1662" width="21" height="21" rx="3" transform="translate(27.369 18.193)" fill="#fff" />
                      <rect id="Rectangle_1663" data-name="Rectangle 1663" width="21" height="21" rx="3" transform="translate(27.369 43.593)" fill="#fff" />
                      <rect id="Rectangle_1664" data-name="Rectangle 1664" width="22" height="21" rx="3" transform="translate(53.08 43.593)" fill="#fff" />
                      <rect id="Rectangle_1665" data-name="Rectangle 1665" width="20.905" height="21.167" rx="3" transform="matrix(0.695, -0.719, 0.719, 0.695, 47.621, 29.631)" fill="#fff" />
                      <rect id="Rectangle_1666" data-name="Rectangle 1666" width="14.634" height="14.895" rx="3" transform="matrix(0.695, -0.719, 0.719, 0.695, 52.055, 29.553)" fill="#fff" />
                      <path fill="#6E87FF" id="Path_12769" data-name="Path 12769" d="M9.808,3.838a.658.658,0,0,0-.483-.2H6.368V.682A.658.658,0,0,0,6.169.2.658.658,0,0,0,5.686,0H4.321a.658.658,0,0,0-.483.2.658.658,0,0,0-.2.483V3.639H.682a.658.658,0,0,0-.483.2.658.658,0,0,0-.2.483V5.686a.657.657,0,0,0,.2.483.658.658,0,0,0,.483.2H3.639V9.325a.679.679,0,0,0,.682.682H5.686a.679.679,0,0,0,.682-.682V6.368H9.325a.679.679,0,0,0,.682-.682V4.321A.658.658,0,0,0,9.808,3.838Z" transform="translate(57.362 24.187)" />
                    </g>
                  </svg> */}
                  </Link>
                  <ReactTooltip id='addwidget' aria-haspopup='true' role='example'>
                    <p>
                      Copy code
                    </p>
                  </ReactTooltip>
                </div>
                <div className="flex-auto left-nav__bottom" style={{ display: 'none' }}>
                  <ul className="user-sidenav-btm">
                    <li>
                      <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`} data-tip data-for='infolink'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25">
                          <g id="Group_306" data-name="Group 306" transform="translate(-297 -389)">
                            <path fill="#c0ccda" id="Path_190" data-name="Path 190" d="M310.428,388a12.428,12.428,0,1,0,12.428,12.428A12.469,12.469,0,0,0,310.428,388Zm1.244,21.131h-2.489v-2.489h2.489Zm2.608-9.571-1.115,1.117a3.862,3.862,0,0,0-1.493,3.477h-2.489v-.618a4.505,4.505,0,0,1,1.493-3.477l1.493-1.62a2.083,2.083,0,0,0,.747-1.735,2.489,2.489,0,0,0-4.977,0h-2.481a4.97,4.97,0,1,1,9.939,0,4.536,4.536,0,0,1-1.117,2.857Zm0,0" transform="translate(-1 1)" ></path>
                          </g>
                        </svg>
                      </Link>
                      <ReactTooltip id='infolink' aria-haspopup='true' role='example'>
                        <p>Support</p>
                      </ReactTooltip>
                    </li>
                    <li>
                      <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`} data-tip data-for='notilink' onMouseEnter={() => this.updLastSeen()}>
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 30.117 37.794">
                          <defs>
                            <clipPath id="clip-path">
                              <rect id="Rectangle_1" data-name="Rectangle 1" width="30.117" height="37.794" fill="#3c4858" />
                            </clipPath>
                          </defs>
                          <g id="bell-icon" transform="translate(-153 -204)">
                            <path id="Path_1" data-name="Path 1" d="M252.906,553.359a5.709,5.709,0,0,0,10.451,0Zm0,0" transform="translate(-90.073 -314.974)" fill="#c0ccda" />
                            <g id="Group_3" data-name="Group 3" transform="translate(153 204)">
                              <g id="Group_2" data-name="Group 2" clipPath="url(#clip-path)">
                                <path id="Path_2" data-name="Path 2" d="M265.833,207.611a12.846,12.846,0,0,1,4.385.768v-.169a4.215,4.215,0,0,0-4.21-4.21h-.349a4.215,4.215,0,0,0-4.21,4.21v.166a12.873,12.873,0,0,1,4.384-.766Zm0,0" transform="translate(-250.775 -204)" fill="#c0ccda" />
                                <path id="Path_3" data-name="Path 3" d="M182.641,289.564H154.963a1.128,1.128,0,0,1-1.112-.865,1.076,1.076,0,0,1,.592-1.224,5.876,5.876,0,0,0,1.787-2.43c1.54-3.254,1.863-7.838,1.863-11.11a10.708,10.708,0,0,1,21.416-.043c0,.014,0,.028,0,.043,0,3.272.323,7.856,1.863,11.11a5.876,5.876,0,0,0,1.787,2.43,1.076,1.076,0,0,1,.592,1.224,1.128,1.128,0,0,1-1.112.865Zm.532-2.082h0Zm0,0" transform="translate(-153.744 -257.398)" fill="#c0ccda" />
                              </g>
                            </g>
                          </g>
                        </svg>
                        {countActivityNotif != 0 && <span className="header-noti-circle">{countActivityNotif}</span>}
                      </Link>
                      <ReactTooltip id='notilink' aria-haspopup='true' role='example'>
                        <p>What's new</p>
                      </ReactTooltip>
                      <ul className="sidenav-dd-hover sidenav-dd-notilist" >
                        {this.props.activity && this.props.activity.length > 0 ?
                          this.props.activity.map((x, i) => {
                            return <li key={i}>
                              <Link className="" to={x.rc} onClick={() => this.updUserClick(x._id, x.ic)}>
                                <span>{x.m}</span>
                              </Link>
                            </li>;
                          })
                          :
                          <li>
                            <span>No activity found.</span>
                          </li>
                        }
                        {/* <li>
                        <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`}>
                          <span>New widget update </span>
                        </Link>
                      </li>
                      <li>
                        <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`}>
                          <span>Pro plan activated on Feb-02-2021  </span>
                        </Link>
                      </li> */}
                      </ul>
                    </li>
                    <li id='widget_profile_menu'>
                      <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}`} data-tip data-for='userdtls'>
                        {
                          this.props.profile && this.props.profile.iu ?
                            <img className="avatar-media" src={this.props.profile && this.props.profile.iu} alt="avtar" />
                            :
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 102 110">
                              <g id="Group_8317" data-name="Group 8317" transform="translate(-567 -202.25)">
                                <circle id="Ellipse_167" data-name="Ellipse 167" cx="25.5" cy="25.5" r="25.5" transform="translate(593 202.25)" fill="#c0ccda" />
                                <path id="Rectangle_1661" data-name="Rectangle 1661" d="M44.855,0h12.9A44.241,44.241,0,0,1,102,44.241v.614A6.145,6.145,0,0,1,95.855,51H6.145A6.145,6.145,0,0,1,0,44.855v0A44.855,44.855,0,0,1,44.855,0Z" transform="translate(567 261.25)" fill="#c0ccda" />
                              </g>
                            </svg>
                        }

                      </Link>
                      <ReactTooltip id='userdtls' aria-haspopup='true' role='example'>
                        <p>Profile</p>
                      </ReactTooltip>
                      <div className="sidenav-dd-hover">
                        <div className="away-admin-details">
                          <img className="avatar-media" src={this.props.profile && this.props.profile.iu ? this.props.profile.iu : 'https://storage.googleapis.com/widget_img/widget/defult-user.png'} alt="avtar" />
                          <div className="avatar-part-right">
                            <div data-tip data-for='name-profile' className="avatar-name">{this.props.profile && this.props.profile.fn}</div>
                            <div data-tip data-for='email-profile' className="avatar-email">{this.props.profile && this.props.profile.e}</div>
                            <ReactTooltip id='name-profile' aria-haspopup='true' role='example'>
                              <p>{this.props.profile && this.props.profile.fn}</p>
                            </ReactTooltip>
                            <ReactTooltip id='email-profile' aria-haspopup='true' role='example'>
                              <p>{this.props.profile && this.props.profile.e}</p>
                            </ReactTooltip>
                          </div>
                        </div>
                        <ul>
                          <li>
                            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}profile`}>
                              {/* <img src={IconIndropSetting} alt="Widget" /> */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 21.083 28.387">
                                <path id="Path_14245" data-name="Path 14245" d="M12.951,11.314A5.657,5.657,0,1,0,7.294,5.657,5.657,5.657,0,0,0,12.951,11.314ZM5.361,28.385a1.673,1.673,0,0,1-1.056-.392,2.5,2.5,0,0,1-.434-.471,5.465,5.465,0,0,1-.56-1.018,11.6,11.6,0,0,1-.777-2.772c-.3-1.948-.223-4.858,2-6.464a14.789,14.789,0,0,1,8.4-2.465h.038a14.81,14.81,0,0,1,8.406,2.468c2.216,1.607,2.287,4.516,1.989,6.462a11.6,11.6,0,0,1-.777,2.772,5.47,5.47,0,0,1-.558,1.018,2.5,2.5,0,0,1-.434.471,1.673,1.673,0,0,1-1.056.392H5.361Z" transform="translate(-2.41)" fill="#c0ccda" />
                              </svg>
                              <span>Profile</span>
                            </Link>
                          </li>
                          <li>
                            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}plan`}>
                              {/* <img src={IconIndropSetting} alt="Widget" /> */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 21.083 28.387">
                                <path id="Path_14245" data-name="Path 14245" d="M12.951,11.314A5.657,5.657,0,1,0,7.294,5.657,5.657,5.657,0,0,0,12.951,11.314ZM5.361,28.385a1.673,1.673,0,0,1-1.056-.392,2.5,2.5,0,0,1-.434-.471,5.465,5.465,0,0,1-.56-1.018,11.6,11.6,0,0,1-.777-2.772c-.3-1.948-.223-4.858,2-6.464a14.789,14.789,0,0,1,8.4-2.465h.038a14.81,14.81,0,0,1,8.406,2.468c2.216,1.607,2.287,4.516,1.989,6.462a11.6,11.6,0,0,1-.777,2.772,5.47,5.47,0,0,1-.558,1.018,2.5,2.5,0,0,1-.434.471,1.673,1.673,0,0,1-1.056.392H5.361Z" transform="translate(-2.41)" fill="#c0ccda" />
                              </svg>
                              <span>Plan</span>
                            </Link>
                          </li>
                          <li>
                            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}payment`}>
                              {/* <img src={IconIndropSetting} alt="Widget" /> */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 21.083 28.387">
                                <path id="Path_14245" data-name="Path 14245" d="M12.951,11.314A5.657,5.657,0,1,0,7.294,5.657,5.657,5.657,0,0,0,12.951,11.314ZM5.361,28.385a1.673,1.673,0,0,1-1.056-.392,2.5,2.5,0,0,1-.434-.471,5.465,5.465,0,0,1-.56-1.018,11.6,11.6,0,0,1-.777-2.772c-.3-1.948-.223-4.858,2-6.464a14.789,14.789,0,0,1,8.4-2.465h.038a14.81,14.81,0,0,1,8.406,2.468c2.216,1.607,2.287,4.516,1.989,6.462a11.6,11.6,0,0,1-.777,2.772,5.47,5.47,0,0,1-.558,1.018,2.5,2.5,0,0,1-.434.471,1.673,1.673,0,0,1-1.056.392H5.361Z" transform="translate(-2.41)" fill="#c0ccda" />
                              </svg>
                              <span>Billing & Invoices</span>
                            </Link>
                          </li>
                          <li>
                            <Link className="" to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}>
                              {/* <img className="" src={IconIndropSetting} alt="Widget" /> */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 25 20">
                                <g id="Feedback" transform="translate(-0.015)">
                                  <path id="Path_14241" data-name="Path 14241" d="M90.015,90h2.339v2.339H90.015Z" transform="translate(-83.202 -83.215)" fill="#c0ccda" />
                                  <path id="Path_14242" data-name="Path 14242" d="M150.015,90h2.339v2.339h-2.339Z" transform="translate(-138.67 -83.215)" fill="#c0ccda" />
                                  <path id="Path_14243" data-name="Path 14243" d="M210.015,90h2.339v2.339h-2.339Z" transform="translate(-194.137 -83.215)" fill="#c0ccda" />
                                  <path id="Path_14244" data-name="Path 14244" d="M.015,20V0h25V15.893H8.238ZM2.288,2.27V16.326l5.414-2.7H22.742V2.27Z" transform="translate(0)" fill="#c0ccda" />
                                </g>
                              </svg>
                              <span>Feedback</span>
                            </Link>
                          </li>
                          <li>
                            <div className="link-sout" onClick={this.handleLogout}>
                              {/* <img src={IconIndropSignout} alt="Widget" /> */}
                              <span>Sign Out</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.getIn(['auth', 'profile']),
  loading: state.getIn(['loading', 'state']),
  activity: state.getIn(['activity', 'activity']),
});

const mapDispatchToProps = {
  getUserActivity, updUserView, updUserClick
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Sidebar);




// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js